import {
	btn,
	checkbox,
	CheckboxField,
	comp,
	cookies,
	fieldset,
	form,
	tbar,
	TextField,
	textfield,
	Window
} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {CurrentSection} from "./services/CurrentSection.js";
import {ServerApi} from "./util/ServerApi.js";
import {Notifier} from "@intermesh/goui";


export class SectionAuth extends Window {

	private locationCodeFld: TextField | undefined;
	private visitorRegistrationCB: CheckboxField | undefined;

	constructor() {
		super();

		this.title = t("Section authentication");
		this.modal = true;
		this.maximizable = false;
		this.draggable = false;
		this.resizable = false;
		this.width = 800;

		sessionStorage.removeItem(CurrentSection.storageItem); // Make sure that section is retrieved from cookie

		CurrentSection.readIf().then(() => {
			const cs = CurrentSection.get(), pc = JSON.parse(localStorage.getItem("portalConfig")!);
			let p;
			if (cs) {
				p = `${t("You are current logged in at")} <strong>${cs.name}</strong><br>${t("Change this by entering a location code for a different section.")}`;
			} else {
				p = t("Provide Location Code to address this location to this computer.")
			}
			this.items.add(comp({tagName: "p", html: p}));
			const f = form({
					flex: 1,
					cls: "vbox",
					handler: (f) => {
						const values = f.value;
						const url = ServerApi.url("elearning/frontend/sections/auth");
						ServerApi.call(url, values, "POST").then((response) => {
							if (response.success) {
								CurrentSection.clear();
								if (response.id === "logout") {
									const pc = JSON.parse(localStorage.getItem("portalConfig")!);
									pc.mayRegister = false;
									localStorage.setItem("portalConfig", JSON.stringify(pc));
									this.close();
									return;
								}
								let msg = "Section login successful";
								CurrentSection.loadSectionAuth(response.sectionAuth, values.remember, values.useSignin)
									.then((_response) => {
										const sc = CurrentSection.get(),
											pc = JSON.parse(localStorage.getItem("portalConfig")!);
										pc.mayRegister = sc.mayRegister;
										localStorage.setItem("portalConfig", JSON.stringify(pc));
										Notifier.notice(t(msg));
									}).finally(() => {
									this.close();
								});
							} else {
								Notifier.warning(t("You entered a noncorrect Location Code"))
							}
						});
					}
				},
				fieldset({flex: 1},
					this.locationCodeFld = textfield({
						label: t("Location code"),
						name: "locationCode",
						required: true,

					}),
					checkbox({
						label: t("Remember location code for this computer?"),
						id: "remember",
						name: "remember"
					}),
					this.visitorRegistrationCB = checkbox({
						label: t("Use visitor registration"),
						id: "useSignin",
						name: "useSignin",
						hidden: !pc.mayUseSignin,
						value: cookies.get("useSignin") !== undefined
					})
				),
				tbar({}, '->',
					btn({
						// type: "submit",
						cls: "",
						text: t("Login"),
						handler: (_btn) => {
							// this.visitorRegistrationCB!.show();
							f.submit();
						}
					}))
			);
			this.items.add(f);
			if (cs) {
				this.locationCodeFld.value = cs.locationCode;
			}
		});
	}
}